import * as React from "react"
import type { BadgeVariant as FoundationBadgeVariant } from "@storyos/design-system/components/ui/badge"
import {
  Badge as FoundationBadge,
  badgeVariants as foundationBadgeVariants,
} from "@storyos/design-system/components/ui/badge"

type StoryOsBadgeVariant =
  | FoundationBadgeVariant
  | "secondary"
  | "outline"
  | "ghost"
  | "link"

type BadgeProps = Omit<
  React.ComponentProps<typeof FoundationBadge>,
  "variant"
> & {
  variant?: StoryOsBadgeVariant
}

function normalizeBadgeVariant(
  variant: StoryOsBadgeVariant | null | undefined
): FoundationBadgeVariant {
  switch (variant) {
    case "destructive":
    case "primary":
    case "success":
    case "warning":
      return variant
    default:
      return "default"
  }
}

function badgeVariants({
  variant,
}: {
  variant?: StoryOsBadgeVariant | null
} = {}) {
  return foundationBadgeVariants({
    variant: normalizeBadgeVariant(variant),
  })
}

function Badge({ variant = "default", ...props }: BadgeProps) {
  return (
    <FoundationBadge
      data-slot="badge"
      data-variant={variant}
      variant={normalizeBadgeVariant(variant)}
      {...props}
    />
  )
}

export { Badge, badgeVariants, type BadgeProps, type StoryOsBadgeVariant }
